import { BaseSerializer } from "./baseSerializer.ts";
import {LoginInfo} from "../loginInfo.model.ts";
import {UserSerializer} from "./userSerializer.ts";

export class LoginInfoSerializer extends BaseSerializer {
    public deserialize(data: Record<string, any>): LoginInfo {
        const loginInfo = new LoginInfo();

        this._copyAttributes(loginInfo, data);

        if (data.user) {
            const userSerializer = new UserSerializer();
            loginInfo.user = userSerializer.deserialize(data.user);
        }

        return loginInfo;
    }
}
